'use client';

import { c as _c } from "react/compiler-runtime";
import { useParams, useRouter } from 'next/navigation';
import { type ReactNode, useCallback, useMemo, useRef } from 'react';
import { useAnswerDispatch, useAnswerStore } from '@/entities/answer/model/hooks';
import { SessionSyncContext } from '@/entities/session/model/sessionSyncContext';
import { getBranchId } from '@/shared/config/funnel/utils/client';
import { abandonFunnelRun } from './abandonFunnelRun';
import { useAnswerSubmissionSync } from './useAnswerSubmissionSync';
import { useCompleteFunnelRun } from './useCompleteFunnelRun';
import { useSyncOnLogin } from './useSyncOnLogin';
export function SessionSyncProvider(t0) {
  const $ = _c(17);
  const {
    children
  } = t0;
  const params = useParams();
  const branchSlug = params.branch;
  let t1;
  if ($[0] !== branchSlug) {
    t1 = typeof branchSlug === "string" ? getBranchId(branchSlug) : null;
    $[0] = branchSlug;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const branchId = t1;
  const store = useAnswerStore();
  const dispatch = useAnswerDispatch();
  const router = useRouter();
  const hasSyncedOnLoginRef = useRef(false);
  let t2;
  if ($[2] !== branchId || $[3] !== dispatch || $[4] !== store) {
    t2 = {
      branchId,
      store,
      dispatch,
      hasSyncedOnLoginRef
    };
    $[2] = branchId;
    $[3] = dispatch;
    $[4] = store;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    persistSubmittedAnswer
  } = useAnswerSubmissionSync(t2);
  const completeRun = useCompleteFunnelRun();
  const syncOnLogin = useSyncOnLogin(hasSyncedOnLoginRef);
  let t3;
  if ($[6] !== dispatch || $[7] !== router) {
    t3 = () => abandonFunnelRun(dispatch, router);
    $[6] = dispatch;
    $[7] = router;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const abandonRun = t3;
  let t4;
  if ($[9] !== abandonRun || $[10] !== completeRun || $[11] !== persistSubmittedAnswer || $[12] !== syncOnLogin) {
    t4 = {
      onAnswerSubmitted: persistSubmittedAnswer,
      completeRun,
      abandonRun,
      syncOnLogin
    };
    $[9] = abandonRun;
    $[10] = completeRun;
    $[11] = persistSubmittedAnswer;
    $[12] = syncOnLogin;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const value = t4;
  let t5;
  if ($[14] !== children || $[15] !== value) {
    t5 = <SessionSyncContext.Provider value={value}>{children}</SessionSyncContext.Provider>;
    $[14] = children;
    $[15] = value;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}